// extracted by mini-css-extract-plugin
module.exports = {"overlay":"ModalWrapper_overlay__1u9lP","container":"ModalWrapper_container__3D5KS","closeButton":"ModalWrapper_closeButton__3lZ9v"};